import Axios from 'axios';

import {
	TRACKING_HISTORY_LOADING_TRUE,
	TRACKING_HISTORY_LOADING_FALSE,
	TRACKING_HISTORY_GET,
	TRACKING_HISTORY_ERROR,
	TRACKING_OVERVIEW_LOADING_TRUE,
	TRACKING_OVERVIEW_LOADING_FALSE,
	TRACKING_OVERVIEW_GET,
	TRACKING_OVERVIEW_ERROR,
	ROUTE_SCHEDULE_LOADING_TRUE,
	ROUTE_SCHEDULE_LOADING_FALSE,
	ROUTE_SCHEDULE_GET,
	ROUTE_SCHEDULE_ERROR
} from './types';

import create_query_params from '../utils/create_query_params';
import { getAreaType } from './overviewActions';

export const tracking_history_loading_true = () => dispatch => {
	dispatch({
		type: TRACKING_HISTORY_LOADING_TRUE
	})
}

export const tracking_history_loading_false = () => dispatch => {
	dispatch({
		type: TRACKING_HISTORY_LOADING_FALSE
	})
}

export const tracking_overview_loading_true = () => dispatch => {
	dispatch({
		type: TRACKING_OVERVIEW_LOADING_TRUE
	})
}

export const tracking_overview_loading_false = () => dispatch => {
	dispatch({
		type: TRACKING_OVERVIEW_LOADING_FALSE
	})
}

export const get_single_route_tracking_history = (filters) => dispatch => {
	dispatch(tracking_history_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + `/api/tracking/history/complete?`;
	let query = create_query_params(filters);
	url += query;

	process.env.REACT_APP_RUNTIME === 'Test' || process.env.REACT_APP_RUNTIME === 'Development'
		&& console.log('tracking_history url =', url);

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: TRACKING_HISTORY_GET,
			payload: res.data
		})
		dispatch(tracking_history_loading_false());
	}).catch((err) => {
		dispatch({
			type: TRACKING_HISTORY_ERROR,
			payload: {type: 'tracking_history', msg: err.message}
		})
		dispatch(tracking_history_loading_false());
	})
}

export const get_tracking_overview = (orgFilters, areaFilters) => dispatch => {
	dispatch(tracking_overview_loading_true());

	const { area_type } = getAreaType(areaFilters);

	const filters = {
		organization: orgFilters.organization,
		workspace: orgFilters.workspace,
		module: orgFilters.module,
		cycle: orgFilters.cycle,
		area_type: area_type
	};

	// Add the specific area filter based on area_type
	if (area_type === '2') {
		filters.region = areaFilters.region;
	} else if (area_type === '3') {
		filters.zone = areaFilters.zone;
	} else if (area_type === '4') {
		filters.depot = areaFilters.depot;
	} else if (area_type === '5') {
		filters.group = areaFilters.group;
	}

	let url = process.env.REACT_APP_SERVER_URL + `/api/tracking/overview?`;
	let query = create_query_params(filters);
	url += query;

	process.env.REACT_APP_RUNTIME === 'Test' || process.env.REACT_APP_RUNTIME === 'Development'
		&& console.log('tracking_overview url =', url);

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: TRACKING_OVERVIEW_GET,
			payload: res.data
		})
		dispatch(tracking_overview_loading_false());
	}).catch((err) => {
		dispatch({
			type: TRACKING_OVERVIEW_ERROR,
			payload: {type: 'tracking_overview', msg: err.message}
		})
		dispatch(tracking_overview_loading_false());
	})
}

export const route_schedule_loading_true = () => dispatch => {
	dispatch({
		type: ROUTE_SCHEDULE_LOADING_TRUE
	})
}

export const route_schedule_loading_false = () => dispatch => {
	dispatch({
		type: ROUTE_SCHEDULE_LOADING_FALSE
	})
}

export const get_route_locations_schedule = (routeId, frequency) => dispatch => {
	dispatch(route_schedule_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + `/api/routes/${routeId}/locations/schedule?frequency=${frequency}`;

	process.env.REACT_APP_RUNTIME === 'Test' || process.env.REACT_APP_RUNTIME === 'Development'
		&& console.log('route_schedule url =', url);

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: ROUTE_SCHEDULE_GET,
			payload: res.data
		})
		dispatch(route_schedule_loading_false());
	}).catch((err) => {
		dispatch({
			type: ROUTE_SCHEDULE_ERROR,
			payload: {type: 'route_schedule', msg: err.message}
		})
		dispatch(route_schedule_loading_false());
	})
}
